import useSWRMutation from "swr/mutation";
import { fetcher } from "src/services/config";
import { MethodType } from "src/services/type";
import { ServicesURL } from "@utils/utilsApi";

interface UseDeleteDraftArgs {
  corporateId: string;
}

export const useDeleteDraft = ({ corporateId }: UseDeleteDraftArgs) => {
  const { trigger, isMutating } = useSWRMutation(
    ServicesURL.v2DraftById,
    async (_key: string, { arg }: { arg: { draftId: number } }) => {
      const url = ServicesURL.v2DraftById
        .replace(":idCorporate", corporateId)
        .replace(":id", String(arg.draftId));
      return fetcher(url, MethodType.DELETE);
    },
  );

  return {
    deleteDraft: (draftId: number) => trigger({ draftId }),
    isDeleting: isMutating,
  };
};
